import AccessoryCommon from "./accessoryCommon";
import {Shower} from "../../parts/shower";
// import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class ShowerRod extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_rod';
    this.partName = 'Shower Rod';
    this.translateId = "visualizer.bathroom.accessories.shower_rod";
    this.visible = true;
    this.canBeDisabled = true;
  }

  handleClick(ignoreLocked = false) {
    const parent = this.getParent()
    const showerParent = parent.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerDoor && !showerParent.showerDoor.disabled) { //  shower tub combo - remove
      showerParent.showerDoor.disabled = true
    }
    super.handleClick(ignoreLocked);
  }

  // navigationSubItems(filters, searchText) {
  //   const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
  //   const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
  //   const parent = this.getParent();
  //   featuresToDisplay.forEach(feature => {
  //     if (parent.layout.parts.Window && parent.layout.parts.Window.windowKits && !parent.layout.parts.Window.windowKits.disabled) {
  //       feature.matchesMetaFailed = true;
  //     } else if (feature.matchesMetaFailed) {
  //       feature.matchesMetaFailed = false;
  //     }
  //   });
  //   return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  // }

  // handleChangeParent(nonCompatibleWith) {
  //   if (nonCompatibleWith === "Window Kit") {
  //     const showerRodParent = this.getParent();
  //     const accessoriesParent = showerRodParent.getParent();
  //     accessoriesParent.layout.parts.Window.windowKits.disabled = true;
  //     showerRodParent.disabled = false;
  //     this.handleClick();
  //   }
  // }

  disabledClick() {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (!this.disabled && showerParent && showerParent.showerDoor && !showerParent.showerDoor.disabled) { //  shower tub combo - remove
      showerParent.showerDoor.disabled = true
    }
  }

  // setZIndex(zIndexes) {
  //   const zIndex = zIndexes.Accessories.ShowerRod;
  //   if (zIndexes && this.activeFeature) {
  //     this.activeFeature.layer.zIndex = zIndex;
  //   }
  // }

}
